export const UNSUBSCRIBE_SUCCESS_MESSAGES = {
    TITLE: "Unsubscribed Successfully",
    DESCRIPTION: "You have been unsubscribed from notifications."
};

export const UNAUTHORIZED_MESSAGES = {
    DEFAULT_TITLE: "404 - Unauthorized Access",
    DEFAULT_DESCRIPTION: "The page you're looking for doesn't exist or you're not allowed here.",
    REFRESH_BUTTON: "Please refresh the browser to reconnect."
};

export const DELETE_CONFIRMATION_MODAL = {
    TITLE: "Delete Conversation",
    MESSAGE: "This conversation will be deleted from your devices."
};

export const NO_RESULTS_MESSAGE = "No results found.";

export const BUTTON_TEXT = {
    LOAD_MORE: "Load More",
    LOADING: "Loading..."
};

export const SecondaryUserDisabledNoticeMessages = {
  title: (displayName) =>
    displayName ? `${displayName} has disabled chats` : "User has disabled chats",
  description: "You will not be able to send messages to this user",
};

export const APPOINTMENT_STATUS = {
    REQUESTED: 0,
    ACCEPTED: 1,
    REJECTED: 2,
    CANCELED: 3,
    DELETED: 4,
    APPOINTMENT: "appointment",
    APPOINTMENT_ACTION: "acknowledged",
    ACCEPT: "Accept",
    REJECT:"Reject"
};
// "request for" covers actions on a pending request; "appointment for" covers canceling an accepted appointment
export const APPOINTMENT_ACTION_PREFIXES = [
    "I have {action} the appointment request for",
    "I have {action} the appointment for",
];
export const APPOINTMENT_ACTION_TYPES = ["accepted", "declined", "canceled"];

export const APPOINTMENT_MESSAGES = {
    TITLE: "Appointment Summary",
    RECIPIENT: "Recipient",
    DATE: "Date",
    TIME: "Time",
    LOCATION: "Location",
    NOTE: "Note",
    STATUS: "Status",
    ACTIONS: {
        EDIT: "Edit Appointment",
        CANCEL: "Cancel Appointment"
    },
    NO_TIME_SPECIFIED: "No Time Specified",
    NO_LOCATION: "No Location"
};
